<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备增值-收入明细
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="ei-income mb-md">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <f-date-range-picker v-model="query.paytime" :shortcuts="[-7, -30, -90]" @change="fetchData(1)" />
        </div>
        <div class="filter-item sm">
          <f-search-input v-model="query.keyword" width="200" placeholder="付款人 / 收费来源" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>
    </div>
    <el-card v-loading="loading" shadow="never">
      <el-table
        ref="listTable"
        :data="list"
        tooltip-effect="dark"
        class="padding-small">
        <el-table-column type="index" label="#" width="50" />

        <el-table-column :show-overflow-tooltip="true" label="付款人" min-width="160">
          <template slot-scope="scope">
            <f-user-avatar :src="scope.row.avatar" />
            <f-user-name class="ml-sm" :user="scope.row" />
          </template>
        </el-table-column>

        <el-table-column label="付款金额" min-width="100">
          <template slot-scope="scope">
            <span class="font-lg text-success">{{ scope.row.total_payed | currency }}</span>
          </template>
        </el-table-column>
  
        <el-table-column label="优惠金额" min-width="100">
          <template slot-scope="scope">
            <span class="font-lg">{{ scope.row.total_discount_fee | currency }}</span>
          </template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="subject" label="收入来源" min-width="140" />

        <el-table-column min-width="120" label="支付时间">
          <template slot-scope="scope">
            <span v-if="scope.row.paytime"> {{ scope.row.paytime | parseTime('{y}/{m}/{d} {h}:{i}') }} </span>
          </template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="detail" label="详情" min-width="180" />
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { incomeListApi } from '@/api/ei/eiApi'
export default {
  name: 'EiIncome',

  data() {
    return {
      loading: false,
      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        keyword: '',
        paytime: null,
        schemeid: null
      },
      list: [],
      schemes: [],
      status: [],
      multiSelection: [],
      total: 0,
    }
  },

  computed: {
    equipEventTypeArr() {
      return this.$store.state.rmsStore.equipEventTypeArr
    },
  },

  created() {
    const keepAlivePath = [
      'rms/member/detail'
    ]
    this.query = this.$utils.initListQuery(this.query, keepAlivePath)
    this.fetchData()
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query)
    next()
  },

  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page
      this.loading = true
      incomeListApi(this.query).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        }
      })
    }
  }
}
</script>

